import React from 'react'
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { RadioGroup } from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import { useState } from 'react';

function ResumeCheckbox({value,onChange}) {
    return (
        <>
            <FormControl component="fieldset" className='resume-radio'>
                <FormGroup>
                    <RadioGroup aria-label="privacy" name="privacy" value={value} onChange={onChange}>
                        <FormControlLabel value="show" control={<Radio />} label="Show" className='text-gray-700 manpro'/>
                        <FormControlLabel value="noshow" control={<Radio />} label="Don't show" className='text-gray-700 manpro'/>
                    </RadioGroup>
                </FormGroup>
            </FormControl>
        </>
    )
}

export default ResumeCheckbox